var path = 'api/Portal/Notification/'

const badgeEnum = {
    Inbox: 10
}

function getBadgeCountFromLinkList (http, badgeE) {
    switch (badgeE) {
    case badgeEnum.Inbox:
        return this.getInboxBadgeCount(http)
    }
}

function getInboxBadgeCount (http) {
    return http.get(path + 'InboxBadgeCount')
}

export default {
    badgeEnum: badgeEnum,
    getBadgeCountFromLinkList: getBadgeCountFromLinkList,
    getInboxBadgeCount: getInboxBadgeCount
}
